module.exports = __webpack_public_path__ + "img/photo_2023-05-16 19.14.37.bcd21f0d.jpeg";